<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/GRgyM1/images/cover.jpg?1734367819100" alt="This image is the cover for the book Spreading My Wings"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Spreading My Wings
      </h1>
      <p class="bookDescription body article font2">
        <b>The remarkable autobiography of a pioneering female aviator who left a privileged life to serve in World War II.</b><br/>  <br/> Her father was a millionaire race-car driver who became chairman of Bentley Motors, and her grandfather cofounded the De Beers mining company. But by the late 1930s, debutante Diana Barnato had enough of her affluent, chaperoned existence and sought excitement in flying—soloing at Brooklands after only six hours’ training.<br/>  <br/> Joining the Air Transport Auxiliary in 1941 to help ferry aircraft to squadrons and bases throughout the country, she flew scores of different aircraft—fighters, bombers, and trainers—in all kinds of conditions, and without a radio. By 1945, Barnato had lost many friends, a fiancé, and a husband—but she continued to fly.<br/>  <br/> In 1962 she was awarded the Jean Lennox Bird Trophy for notable achievement in aviation, but her greatest moment was yet to come, when in 1963 she flew a Lightning through the sound barrier, becoming “the fastest woman in the world.” <i>Spreading My Wings</i> is her remarkable memoir, brimming with history and adventure.<br/>  <br/>  
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Diana Barnato Walker
      </h2>
      
      <p class="authorDescription body article">Diana Barnato Walker specializes in aviation.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Grub Street Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?c2422148